
export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            小さく、賢く、自分らしく。
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            二人暮らしにぴったりの「ちょこっとハウス」誕生！
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
                <i className="ri-chat-quote-line text-2xl text-orange-500"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                こんなお悩みはありませんか？
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl mb-4">🏠</div>
                <p className="text-gray-700 font-medium">
                  「もう広い家は<br />いらない」
                </p>
              </div>
              
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl mb-4">❄️</div>
                <p className="text-gray-700 font-medium">
                  「雪下ろしも<br />体がきつい」
                </p>
              </div>
              
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl mb-4">😰</div>
                <p className="text-gray-700 font-medium">
                  「でもアパート暮らしは<br />年齢的にちょっと心配…」
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">
            そんな50代・60代のご夫婦、<br />
            パートナー同士の方へ。
          </h3>
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed">
              秋田県湯沢・横手エリアで二人暮らしにちょうどいい<br />
              <span className="font-bold text-orange-500">15坪ほどの1K住宅</span>、<br />
              その名も<span className="font-bold text-orange-500">「ちょこっとハウス」</span>をつくりました。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/abdb8b42a73207252063274ff27ec62f.jpg"
              alt="ちょこっとハウス内観"
              className="w-full h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>
          
          <div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <i className="ri-home-4-line text-xl text-orange-500"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">コンパクト設計</h4>
                  <p className="text-gray-600">15坪の効率的な間取りで、お二人の生活に必要十分な空間を実現</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-xl text-orange-500"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">経済的</h4>
                  <p className="text-gray-600">建築費用を抑え、維持管理費も最小限に</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-xl text-orange-500"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">安心・安全</h4>
                  <p className="text-gray-600">年齢を重ねても安心して住み続けられる設計</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
